export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-02.06f8b756.jpg";